import ScaleLoader from "react-spinners/ScaleLoader";

const Spinner = ({ wait, children = [], color, style, center, absolute, width = "100%", height = 25, glass = false, show_spinner = true }) => {
    color = color ? color : "#fff";
    if (wait)
        if (center)
            return (
                <div
                    style={{
                        ...(!glass && { display: "flex", width, height: "100%", verticalAlign: "middle", justifyContent: "center", alignItems: "center" }),
                        ...(() => absolute && { position: "absolute" })(),
                        ...(glass ? { position: "relative" } : {}),
                    }}
                >
                    {glass && <div style={{ filter: "blur(2px)" }}>{children}</div>}
                    {glass && <div style={{ top: 0, position: "absolute", backgroundColor: "#716c6c29", filter: "blur(4px)", height: "100%", borderRadius: 10, width: "100%" }} />}
                    <div
                        style={{
                            ...(glass && { display: "flex", width, height: "100%", verticalAlign: "middle", justifyContent: "center", alignItems: "center", position: "absolute", top: 0 }),
                        }}
                    >
                        {show_spinner && <ScaleLoader color={color} loading={true} height={height} css={{ ...style, display: "flex", width: "100%", justifyContent: "center" }} />}
                    </div>
                </div>
            );
        else
            return (
                <ScaleLoader
                    color={color}
                    loading={true}
                    height={height}
                    css={{ ...style, display: "flex", width, justifyContent: "center", height: "100%", ...(() => absolute && { position: "absolute" })() }}
                />
            );
    else return children;
};

export default Spinner;
